module.exports = __webpack_public_path__ + "static/6-4f6d155f23b2fd29ce6f9f2e1f630611.jpg";